module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_vm._v("Mary thought of making a run for the front door, then remembered the phone by her bed. Keeping her eyes on the hall, she slid toward the nightstand.")])]), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("There was another noise, not so soft this time. A footstep, followed by the sound of something—of someone—brushing against the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mary’s heart bounced in her chest. Fear ran through her body like strong acid. With trembling fingers she lifted the receiver of the phone and brought it up to her ear. In the silence the dial tone seemed impossibly loud. Surely whoever was out in the hallway would hear it. Surely he would know what Mary was trying to do.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59b8099e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm01.vue
// module id = 60
// module chunks = 0